class AdpTooltipController {
  constructor() {
    this.name = 'adpTooltip';
  }
  toggle() {
    this.opened = !this.opened;
  }
}

export default AdpTooltipController;



// WEBPACK FOOTER //
// ./src/app/components/adpTooltip/adpTooltip.controller.js